import { TahunContext } from "@/contexts/TahunContext"
import { useContext } from "react"

export const useTahun = () => {
  const context = useContext(TahunContext)
  if (!context) {
    throw new Error("useTahun must be used within a TahunProvider")
  }
  return context
}
